"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreLibraryInitialised = void 0;
function coreLibraryInitialised() {
    // @ts-ignore
    return typeof GlamCornerCore !== "undefined";
}
exports.coreLibraryInitialised = coreLibraryInitialised;
